import { hasWindow } from '@/utils/dom';
import { useSyncExternalStore } from 'react';

function useMediaQuery(query: string): boolean {
	const subscribe = (onStoreChange: () => void) => {
		if (!hasWindow()) {
			return () => undefined;
		}

		const mediaQueryList = window.matchMedia(query);
		const handleChange = () => {
			onStoreChange();
		};

		mediaQueryList.addEventListener('change', handleChange);

		return () => {
			mediaQueryList.removeEventListener('change', handleChange);
		};
	};

	const getSnapshot = () => {
		if (!hasWindow()) {
			return false;
		}

		return window.matchMedia(query).matches;
	};

	return useSyncExternalStore(subscribe, getSnapshot, () => false);
}

export default useMediaQuery;
